import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { getSettlement } from '../settlements.endpoints';
import { Settlement } from '../../../Models';

export type GetSettlement = UseQueryResult<Settlement | undefined> & {
    settlement: Settlement | undefined;
};
export const useGetSettlement = (orderId: string): GetSettlement => {
    const hook = useQuery<Settlement | undefined>({
        queryKey: ['getGetSettlement', orderId],
        queryFn: () => getSettlement(orderId),
        initialData: undefined,
        retry: false,
        staleTime: Infinity,
        cacheTime: Infinity,
    });

    return { ...hook, settlement: hook.data };
};
